import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import ReactCollapse from 'react-collapse';

import { ContentZonesService, LocaleService } from '@sm360/widget-commons-core-services';
import { ModelYear } from '@sm360/widget-commons-vehicle';
import { ADOBE_TAGS, AdobeService, ADOBE_VARIANT_CONSTANTS } from '@sm360/widget-commons-general';

import { OPTIONS_PACKAGES } from 'build-and-quote/constants/sections.js';
import OptionsPackage from 'build-and-quote/components/OptionsPackages/OptionsPackage.jsx';
import { getSectionAdditionalClasses } from 'build-and-quote/services/SectionClassesUtils/SectionClassesUtils.js';

import 'build-and-quote/components/OptionsPackages/optionsPackages.scss';

const OptionsPackages = ({
    availableOptionsPackages,
    currentSection,
    selectedModel,
    selectOptionsPackage,
    hasAdobeTagging,
}) => {
    const sectionOpened = currentSection === OPTIONS_PACKAGES.value;

    useEffect(
        () => {
            if (sectionOpened && hasAdobeTagging) {
                AdobeService.eventTrigger(ADOBE_TAGS.BUILDER_STEPS('comfort'), ADOBE_VARIANT_CONSTANTS.GLOBAL_OVERLAY);
            }
        },
        [sectionOpened]
    );

    const optionPackageTrainList = availableOptionsPackages.map((optionsPackage, index) => (
        <OptionsPackage
            key={optionsPackage.selectionCode}
            optionIndex={index + 1}
            optionsPackage={optionsPackage}
            onOptionsPackageClick={() => selectOptionsPackage(optionsPackage)}
        />
    ));

    const availableOptionsPackagesSection = availableOptionsPackages.length > 0 && (
        <div className="bloc-options__listing">{optionPackageTrainList}</div>
    );

    const sectionClasses = ['bloc-container', 'section-drive-power-trains', 'section-background'];
    const sectionAdditionalClasses = getSectionAdditionalClasses(
        sectionClasses,
        sectionOpened,
        currentSection,
        OPTIONS_PACKAGES.value
    ).join(' ');

    const genericTitle = ContentZonesService.getContentZone('widget.build.and.buy', 'vehicle.title.text')
        ? ContentZonesService.getContentZone('widget.build.and.buy', 'vehicle.title.text').getValue()
        : LocaleService.t('modelYearSection.title');

    const sectionTitle = LocaleService.t('SECTIONS.TITLE.GENERAL', {
        title: genericTitle,
        model: `${selectedModel.model}`,
    });

    const sectionSubtitle =
        availableOptionsPackages.length > 1
            ? LocaleService.t('drivePowerTrainSection.subtitle_2', {
                  optionlength: `${availableOptionsPackages.length}`,
              })
            : LocaleService.t('drivePowerTrainSection.subtitle_1', {
                  optionlength: `${availableOptionsPackages.length}`,
              });

    const backgroundCZ = ContentZonesService.getContentZone('widget.build.and.buy', 'Comfort.background.img');
    const background = backgroundCZ && `url(${backgroundCZ.getValue()})`;

    return (
        <ReactCollapse isOpened={sectionOpened} springConfig={{ stiffness: 140, damping: 26 }}>
            <section className={sectionAdditionalClasses} style={{ backgroundImage: background }}>
                <div className="bloc-container-wrapper">
                    <div className="section-package__title">
                        <h3 className="sr-subtitle-1 is-centered">{sectionTitle}</h3>
                        <h4 className="sr-title-1 is-centered">{sectionSubtitle}</h4>
                    </div>
                    {availableOptionsPackagesSection}
                </div>
            </section>
        </ReactCollapse>
    );
};

OptionsPackages.defaultProps = {
    selectedModel: [],
    hasAdobeTagging: false,
};

OptionsPackages.propTypes = {
    availableOptionsPackages: PropTypes.arrayOf(PropTypes.instanceOf(ModelYear.OptionsPackageModel)).isRequired,
    currentSection: PropTypes.number.isRequired,
    selectedModel: PropTypes.shape({
        make: PropTypes.string.isRequired,
        model: PropTypes.string.isRequired,
    }),
    selectOptionsPackage: PropTypes.func.isRequired,
    hasAdobeTagging: PropTypes.bool,
};

OptionsPackages.displayName = 'OptionsPackages';

export default OptionsPackages;
